// routeSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentOpenDropdown: null,
  dropdownStates: {
    manageUsers: false,
    product: false,
    order: false,
    purchase: false,
    discountOpen: false,
    isManageCustomersDropdownOpen: false,
    isManageSuppliersDropdownOpen: false,
  },
};

const routeSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    setCurrentOpenDropdown: (state, action) => {
      state.currentOpenDropdown = action.payload;
    },
  },
});

export const { setCurrentOpenDropdown } = routeSlice.actions;
export default routeSlice.reducer;
